import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders, HttpParams} from '@angular/common/http'
import { environment } from '../../environments/environment';
import { HttpResponseHandlerService } from '../services/http-response-handler.service';
import * as _ from 'underscore';
import {catchError,  map, share } from 'rxjs/operators';
import { Observable, of, Subscriber } from 'rxjs';


@Injectable()
export class AjaxService {

  header;
  sessionout : boolean= false;
  isMaintainance: boolean = false;
  profileBalanceCurrency:any=null;

  constructor(
    private http: HttpClient, 
    private httpResponseHandlerService:HttpResponseHandlerService,
  ) {
    this.header = new HttpHeaders({ "content-type": "application/x-www-form-urlencoded", "accept": "application/json, text/plain, */*"});
  }


  get(searchParams,url): Observable<String>{
    let apiUrl = environment.apiUrl + url;
    return this.http.get(apiUrl, { withCredentials: true, params: searchParams }).pipe(map(res => {
      return this.httpResponseHandlerService.handleHTTPResponse(res);
    }), share()).pipe(catchError((e: any) => {
      console.log(
        "---------------------->Error: ",
        JSON.stringify(e),
        url,
        JSON.stringify(searchParams)
      );
      return this.httpResponseHandlerService.handleHTTPError(e,url,"true");
    }));
  }

  psPost(url,params): Promise<String>{
    return new Promise((resolve,reject)=>{
      let headers = new HttpHeaders({ "content-type": "application/x-www-form-urlencoded",
         "accept": "application/json, text/plain, */*"});
      if(url.includes('upload')){
        headers = new HttpHeaders();
        headers.set('Content-Type', undefined);
        //headers.set('Upload-Content-Type', params.type)
        this.http.post(environment.apiUrl+url,params,{withCredentials: true})
        .toPromise().then(
            data => {
              let response = this.httpResponseHandlerService.handleHTTPResponse(data);
            if ( response ) {
              resolve(response);
            } else {
              reject(response);
            }
            }
          ).catch(e =>{
            this.httpResponseHandlerService.handleHTTPError(e,url);
        });
     }else{
       headers = new HttpHeaders({ "content-type": "application/x-www-form-urlencoded",
      "accept": "application/json, text/plain, */*"});
      this.http.post(environment.apiUrl+url,params,{withCredentials: true,headers:headers})
      .toPromise().then(
          data => {
            let response = this.httpResponseHandlerService.handleHTTPResponse(data);
          if ( response ) {
            resolve(response);
          } else {
            reject(response);
          }
          }
        ).catch(e =>{
            this.httpResponseHandlerService.handleHTTPError(e,url);
        });
     }
    })
  }
  psGet(searchParams,url): Promise<String>{
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiUrl+url,{withCredentials: true,params:searchParams})
       .toPromise().then(
          data => {
            let response = this.httpResponseHandlerService.handleHTTPResponse(data);
            if(response) resolve(response);
          }
        ).catch(e =>{
          this.httpResponseHandlerService.handleHTTPError(e,url);
        });
    })

}

  getUrlParams(fields):HttpParams{
    let urlParams = new HttpParams();
    _.each(fields, function(value,key) {
      urlParams = urlParams.append(key, value);
    });
    return urlParams;
  }

  getSearchParams(searchData){
    searchData["languageId"] = this.getActualMappedLanguage(searchData["lang"]);
    if (searchData && !searchData["lang"]) {
      searchData["lang"] = this.getActualMappedLanguage()
    }

    let searchParams = new HttpParams();
    _.each(searchData, function(value,key) {
      searchParams = searchParams.set(key, value);
    });
    return searchParams;
  }

  getLoginStatus(): Promise<String>{
    return this.psGet('','/ajax/login/status');
  }

  doLogin(credentials): Promise<String>{
    this.sessionout =false;
    return this.psPost('/ajax/login',this.getUrlParams(credentials));
  }

  
  doLogout(): Promise<String>{
    return this.psPost('/ajax/login/logout',{});
  }

  profileBalanceCallStack:Subscriber<any>[]=[]
  profileBalanceAPI = this.http.get(environment.apiUrl+'/ajax/profile/getProfileBalanceCurrency',{withCredentials: true}).pipe(share())
  getProfileBalanceCurrency(force=false){
    
    if(this.profileBalanceCurrency && force===false) return of(this.profileBalanceCurrency);

      
    return new Observable((resolve)=>{

      if(this.profileBalanceCallStack.length>0){
        this.profileBalanceCallStack.push(resolve);
      }else{
        this.profileBalanceCallStack.push(resolve);
        this.profileBalanceAPI.subscribe((data)=>{
          this.profileBalanceCurrency=data;
          for (let callback in  this.profileBalanceCallStack){
            this.profileBalanceCallStack[callback].next(this.profileBalanceCurrency);
          }
          this.profileBalanceCallStack=[];
        });
      }

    });
    
  }

  getCountries(): Promise<String>{
    return this.psGet('','/ajax/profile/getCountryDetails');
  }
  getFreeSpinGames():Observable<any>{
    return this.get("", '/ajax/profile/getFreeSpinGames');
  }
  getActiveBonus():Observable<any>{
    return this.get("", '/ajax/Bonus/activeBonusDetails');
  }
  getEnabledCurrencies(){
    return this.http.get(environment.apiUrl+'/ajax/profile/getEnabledCurrency',{withCredentials: true});
  }
  getPendingWithdrawls(): Promise<String>{
    return this.psGet('','/ajax/getCashierData');
  }
  canclePendingWithdrawls(txnIdAndAmt): Promise<String>{
    return this.psPost('/ajax/Cashier/revertWithdrawal',this.getUrlParams(txnIdAndAmt));
  }
  validateUniqueness(fieldToValidate): Promise<String>{
    let url;
    _.each(fieldToValidate, function(value,key) {
        url = key === "txtNickname" ? '/ajax/registration/isUniqueNickname' : '/ajax/registration/isUniqueEmail';
    });
    return this.psPost(url,this.getUrlParams(fieldToValidate));
  }

  validateCheckMobile(fieldToValidate): Promise<String>{
    let url;
    /*_.each(fieldToValidate, function(value,key) {
        url = key == "txtNickname" ? '/ajax/registration/isUniqueNickname' : '/ajax/registration/isUniqueEmail';
    });*/
    return this.psPost('/ajax/registration/checkUserPhoneAvailablity',this.getUrlParams(fieldToValidate));
  }

  doRegistration(registrationDetails): Promise<String>{
    return this.psPost('/ajax/registration',this.getUrlParams(registrationDetails));
  }

  doProfileUpdate(UpdateProfileDetails): Promise<String>{
    return this.psPost('/ajax/profile/update',this.getUrlParams(UpdateProfileDetails));
  }

  doCredentialsUpdate(UpdateProfileDetails): Promise<String>{
    return this.psPost('/ajax/profile/updateUserCredentials',this.getUrlParams(UpdateProfileDetails));
  }

  getProfileData(): Promise<String>{
    return this.psGet('','/ajax/profile/getData');
  }

  changePassword(changePasswordData): Promise<String> {
    return this.psPost('/ajax/profile/changePassword',this.getUrlParams(changePasswordData));
  }

  resetPassword(pwdDetails): Promise<String>{
    let pwdDet = new HttpParams();
    _.each(pwdDetails, function(value,key) {
      pwdDet = pwdDet.append(key, value);
    });
    return this.psPost('/ajax/resetPassword/doResetPassword',pwdDet);
  }
  forgotPassword(emailDetails): Promise<String>{
    let emailDet = new HttpParams();
    _.each(emailDetails, function(value,key) {
      emailDet = emailDet.append(key, value);
    });
    return this.psPost('/ajax/resetPassword',emailDet);
  }
  getAccountVerificationStatus(): Promise<String>{
    return this.psGet('','/ajax/profile/getAccountVerificationStatus');
  }
  approveDepositLimit(approvedData){
    let data = new HttpParams();
    _.each(approvedData, function(value,key) {
      data = data.append(key, value);
    });
    return this.psPost('/ajax/ResponsibleGaming/confirmDepositLimits',data);
  }
  approveWagerLossLimit(approvedData){
    let data = new HttpParams();
    _.each(approvedData, function(value,key) {
      data = data.append(key, value);
    });
    return this.psPost('/ajax/ResponsibleGaming/confirmLimits',data);
  }
  uploadFileToSession(idProof):Promise<String>{
    let formData:FormData = new FormData();
		 formData.append('file', idProof.file);
    return this.psPost(idProof.url,formData);
  }

  submitUploadedFiles(requestObj?) {
    let request = requestObj ?requestObj: "";
    return this.psPost("/ajax/account/Documents/send",this.getUrlParams(request));
  }

  getGames(){
    let data={}
    return this.psGet(this.getSearchParams(data),"/ajax/game/getGames");
  }

  isBlockedCountry():Promise<any>{
    return this.psGet('','/ajax/country/countryBlock');
  }

  updateSubscriptionPreferenes(subscriptionPrefData): Promise<String>{
    return this.psPost('/ajax/profile/updateSubscriptionPreferenes',this.getUrlParams(subscriptionPrefData));
  }

  getSubscriptionPreferenes(): Promise<String>{
    return this.psPost('/ajax/profile/getSubscriptionPreferenes',"subscriptionPref");
  }

  getUserTransactionsHistory(request):any{
    let txnReq = new HttpParams();
    txnReq = txnReq.append("criteria",JSON.stringify(request));
    return this.psPost('/ajax/Report/getTransactionHistory',txnReq);
  }

  getUserBetHistory(request):any{
    let betReq = new HttpParams();
    betReq = betReq.append("criteria",JSON.stringify(request));
    return this.psPost('/ajax/Report/getTransactionHistory',betReq);
  }

  getEligibleBonuses(): Promise<String>{
    return this.psGet('','/ajax/bonus/getEligibleBonuses');
  }

  getCasinoGames(gameId): Promise<any> {
    let langObj = {languageId: "en", lang: "en"}
    if (!gameId) {
      return this.psGet(langObj,'/ajax/game/getgames');
    } else {
      return this.psGet(langObj,'/ajax/game/getgames/' + gameId);
    }
  }

  getLatestPlayedGames() {
    return this.psGet('','/ajax/profile/getLastPlayedGames?limit=6');
  }
  // lauchGame(gamePlayData):Promise<any>{
  //   return this.psGet("","/launcher/"+gamePlayData.gameType+"/index/"+gamePlayData.gameId);
  // }
  resendEmailVerification(credentials): Promise<String>{
    let resendCodeDetails = new HttpParams();
    _.each(credentials, function(value,key) {
      resendCodeDetails = resendCodeDetails.append(key, value);
    });
    return this.psPost('/ajax/registration/sendChannelVeification',resendCodeDetails);
  }

  suspendAccount(credentials): Promise<String>{
    let reason = new HttpParams();
    _.each(credentials, function(value,key) {
      reason = reason.append(key, value);
    });
    return this.psPost('/ajax/ResponsibleGaming/lockAccount',reason);
  }
  checkUserProfile():Promise<String>{
    return this.psPost('/ajax/profile/checkUserProfile',"");
  }

  lauchGame(gameType, gameId, langCode):Promise<any>{
    if(langCode === 'in'){
      langCode = 'ei'
    }
    if(gameType === "realgames"){
      return this.psGet('','/ajax/launcher/getRealGames?gameCode='+gameId+'&languageId='+langCode);
    }else{
      return this.psGet('','/ajax/launcher/getFreeGames?gameSymbol='+gameId+'&languageId='+langCode);
    }
  }
  doVerifyOtp(credentials): Promise<String>{
    let otpVerDetails = new HttpParams();
    _.each(credentials, function(value,key) {
      otpVerDetails = otpVerDetails.append(key, value);
    });
    return this.psPost('/ajax/registration/verifyChannel',otpVerDetails);
  }

  getAvailablePaymentMethodLimits(){
    return this.psGet('',"/ajax/cashier/getAvailablePaymentMethodsLimits");
  }
  getCashierData(): Promise<String> {
    return this.psGet('','/ajax/cashier/getCashierData');
  }

  getTransactionStatus(txnDetails): Promise<String> {
    let details = new HttpParams();
      _.each(txnDetails, function(value, key) {
        details = details.append(key, value);
      });
    return this.psPost('/ajax/cashier/gettransationStatus', details);
  }

  makePayment(cc): Promise<String> {
    let ccDetails = new HttpParams();
    _.each(cc, function(value, key) {
      ccDetails = ccDetails.append(key, value);
    });
    return this.psPost(cc.paymentMethod === 'CREDITCARD' ? '/ajax/cashier/makeCCPayment' : '/ajax/cashier/makeWalletPayment' , ccDetails);
  }
  getBalance(): Promise<String>{
    return this.psPost('/ajax/profile/getbalance',"");
  }

  getStates(country): Promise<String>{
    let countryName = new HttpParams();
    _.each(country, function(value,key) {
      countryName = countryName.append(key, value);
    });
    return this.psGet('/ajax/profile/getStateDetails',countryName);
  }

  makeWithdraw(cc):Promise<String>{
    let ccDetails = new HttpParams();
    _.each(cc, function(value,key) {
      ccDetails = ccDetails.append(key, value);
    });
    return this.psPost(cc.paymentMethod === "CREDITCARD" ? '/ajax/cashier/makeCCWithdrawal' : '/ajax/cashier/makeWalletWithdrawal',ccDetails);
  }

  // getResponsibleGamingData(): Promise<[String,String]>{
  //   return Promise
  //     .all([
  //         Promise.resolve(this.getDepositLimit()),
  //         Promise.resolve(this.getSessionLimit())
  //       ])
  //     .then(values => {
  //       return values;
  //     });
  // }

  getDepositLimit(): Promise<String>{
    return this.psGet('','/ajax/balance/getDepositLimit');
  }
  getWagerLimit(): Promise<String>{
    return this.psGet('','/ajax/balance/getWagerLimit');
  }
  getLossLimit(): Promise<String>{
    return this.psGet('','/ajax/balance/getLossLimit');
  }
  getSessionLimit(): Promise<String>{
    return this.psGet('','/ajax/balance/getSessionLimit');
  }
  cancelLimits(data): Promise<String>{
    let cancelDetails = new HttpParams();
    let url;
    _.each(data, function(value,key) {
      cancelDetails = cancelDetails.append(key, value);
    });
    return this.psPost('/ajax/ResponsibleGaming/cancelLimits',cancelDetails);
  }

  deleteLimits(data): Promise<String>{
    let cancelDetails = new HttpParams();
    let url;
    _.each(data, function(value,key) {
      cancelDetails = cancelDetails.append(key, value);
    });
    return this.psPost('/ajax/ResponsibleGaming/deleteLimits',cancelDetails);
  }

  setLimits(credentials): Promise<String>{
    let limttAndType = new HttpParams();
    _.each(credentials, function(value,key) {
      limttAndType = limttAndType.append(key, value);
    });
    return this.psPost('/ajax/ResponsibleGaming/setLimits',limttAndType);
  }
  getBanners(bannerData):Promise<any>{
    return this.psGet(this.getSearchParams(bannerData),'/ajax/banner/getBanners');
  }

  getStaticPage(data):Promise<any>{
    let params=this.getSearchParams(data);
    if(params.has('lang')){
      params =params.set('language',this.getActualMappedLanguage(params.get('lang')));
      params = params.delete('lang');
    }
    return this.psGet(params,'/ajax/staticPage/getPage');
  }

  getPromos(affId){
    return this.psGet(this.getSearchParams(affId),'/ajax/promotion/getPromotions');
  }
  getActiveBonuses(){
    return this.psGet("",'/ajax/Bonus/activeBonusDetails');
  }

  getChannelVerificationStatus(){
      return this.psPost('/ajax/cashier/channelVerificationStatus',"");
  }


  doContact(contact): Promise<String>{
    let contactDetails = new HttpParams();
    _.each(contact, function(value,key){
      contactDetails = contactDetails.append(key, value);
    });
    return this.psPost('/ajax/registration/contactUs',contactDetails);
  }

  getPNPMinMaxTxnLimits(payLoad){
    return this.psGet(payLoad,"/ajax/payAndPlayTrustly/getPNPMinMaxTxnLimits");
  }
  getPNPDepositFee(payLoad){
    return this.psGet(payLoad,"/ajax/payAndPlayTrustly/getPNPDepositFee");
  }
  britePayAndPlayInit(requestData):Promise<any>{
    return this.psPost('/ajax/briteplay/initiatePayAndPlay', this.getUrlParams(requestData));
  }
  quickRegisterBrite(requestData):Promise<any>{
    return this.psPost('/ajax/briteplay/quickRegisterBritePlay', this.getUrlParams(requestData));
  }

  initPNPDeposit(payLoad){
    return this.psPost('/ajax/payAndPlayTrustly/initPNPDeposit',this.getUrlParams(payLoad));
  }
  getPNPQuickRegister(payLoad){
    return this.psPost("/ajax/payAndPlayTrustly/getPNPQuickRegister",this.getUrlParams(payLoad));
  }
  getthirdPartyLogin(payload){
    return this.psGet(payload,"/ajax/payAndPlayTrustly/getPNPThirdPartyLogin");
  }
  getPNPUserFromTransaction(payload){
    return this.psGet(payload,"/ajax/payAndPlayTrustly/getPNPUserFromTransaction");
  }
  getS2SaffliateIdsMap(){    
  return this.psGet("",'/ajax/Affiliate/affiliatePixelTrackingList');   
  }
  activatePNP(payLoad) {
    return this.psPost("/ajax/payAndPlayTrustly/activatePNP", this.getUrlParams(payLoad));
  }
  getUserLifeTimeTransactionSummary() {
    return this.http.get(environment.apiUrl+'/ajax/cashier/getPlayerLifeTimeSummary',{withCredentials: true});
  }

  getFaqQuestionsAndCategory(faqData): Promise<any> {
    faqData.lang = this.getActualMappedLanguage(faqData.lang);
    return this.psGet(this.getSearchParams(faqData), '/ajax/faq/getQuestions');
  }

  zimplerPayAndPlayInit(requestData):Promise<any>{
    return this.psPost('/ajax/zimpler/zimplerPayAndPlayInit', this.getUrlParams(requestData));
  }

  quickRegisterZimpler(requestData):Promise<any>{
    return this.psPost('/ajax/zimpler/quickRegisterZimpler', this.getUrlParams(requestData));
  }

  getPendingCashOuts(pendingWithdrawalObject?):Promise<any>{
    return this.psGet(this.getUrlParams(pendingWithdrawalObject),'/ajax/cashier/getPendingCashouts');
  }
  
  getLobbies(){
    let enLangGameLoad = {languageId:  this.getActualMappedLanguage()}
    return this.get(enLangGameLoad, '/ajax/game/getLobbyListWithGameGroups');
  }

  getGamesWithGameGroup(){
    let enLangGameLoad = {language: "en"}
    return this.get(enLangGameLoad, '/ajax/game/getLobbyGameGroupGames');
  }

  setFavouriteGames(newState, gameID) {
    let requestObj = {
      newState: newState,
      gameID: gameID
    }
    return this.psPost('/ajax/profile/toggleFavoriteGame', this.getUrlParams(requestObj));
  }

  depositeProcess(data){
    return this.psPost("/ajax/cashier/makeWalletPayment",this.getUrlParams(data))
  }
  getCahsierConfiguareationMethod(){
    return this.psGet('',"/ajax/cashier/getCashierIntegrationConfig")
  }
  getFavouriteGames() {
    return this.psPost('/ajax/profile/getFavouriteGames', '');
  }
  getActualMappedLanguage(lang = null){
    if(!lang){
      lang = localStorage.getItem('langCode');
    }
    if(lang && environment.specifiedMappedLanguages[lang] ){
       return environment.specifiedMappedLanguages[lang];
    }else{
      return localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en';
    }
  }
  getPolicies(): Observable<any>{
    return this.get("", "/ajax/policy/getPolicies");
  }
  getUserPolicyDetails():Observable<any>{
    return this.get("", "/ajax/policy/getUserPolicyDetails");
  }
  updateUserPolicyDetails(policyDetails){
    return this.psPost('/ajax/policy/updateUserPolicyDetails',this.getUrlParams(policyDetails));
  }
  getUserSegments():Observable<any>{
    return this.get("", "/ajax/segment/getUserSegments");
  }

  getActiveLanguage():Observable<any>{
    return this.get("","/ajax/language/getActiveLanguages")
  }

  generateTugiJwtTocken():Observable<any>{
    return this.get("", "/ajax/chat/jwt/generate")
  }
}
